var map = {
	"./3d-2.svg": "f7a9",
	"./3d-3.svg": "e780",
	"./3d.svg": "15e5",
	"./audio-2.svg": "7eb5",
	"./audio-3.svg": "ec93",
	"./audio.svg": "dbdd",
	"./audioresize40.svg": "09fb",
	"./done.svg": "3878",
	"./gif-2.svg": "b334",
	"./gif-3.svg": "ba3b",
	"./gif.svg": "2b2d",
	"./image-2.svg": "f480",
	"./image-3.svg": "7cfb",
	"./image.svg": "d19f",
	"./nhom-hoc-lieu-2.svg": "f211",
	"./nhom-hoc-lieu-3.svg": "11bc",
	"./nhom-hoc-lieu.svg": "134e",
	"./pause.svg": "308f",
	"./play-2.svg": "697b",
	"./play-3.svg": "bb01",
	"./play.svg": "58d3",
	"./playresize.svg": "29ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9b6";